/* MCR: clones the first affiliate link on a product review page into an above-the-fold CTA */
(function () {
function init() {
if (document.querySelector('.mcr-atf')) { return; }
if (!document.body.classList.contains('template-product')) { return; }
var scope = document.querySelector('.product-text') || document;
var src = scope.querySelector('a[href*="trackcb"]');
if (!src) { return; }
var price = document.querySelector('.product-price');
if (!price || !price.parentNode) { return; }
var url;
try { url = new URL(src.href); } catch (e) { return; }
url.searchParams.set('aff_sub2', 'atf-cta');
var wrap = document.createElement('div');
wrap.className = 'mcr-atf';
var link = document.createElement('a');
link.className = 'mcr-atf-btn';
link.href = url.toString();
link.target = '_blank';
link.rel = 'sponsored nofollow noopener';
var label = (src.textContent || '').trim();
link.textContent = label.length > 2 ? label : 'Check Current Price';
var note = document.createElement('span');
note.className = 'mcr-atf-note';
note.textContent = 'Ships direct from the brand. We may earn a commission.';
wrap.appendChild(link);
wrap.appendChild(note);
price.parentNode.insertBefore(wrap, price.nextSibling);
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}
})();
